// extracted by mini-css-extract-plugin
module.exports = {"card":"py-z"};